import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { Box } from 'roo-ui/components';
import { StepHeader } from 'components/StepWizard';
import PersonalDetailsForm from './PersonalDetailsForm';

const PersonalDetails = ({ step, ...rest }) => {
  const { edit, hasState, stepNumber } = step;

  return (
    <Box bg="white" borderRadius="default" boxShadow="hard" ref={step.containerRef} {...rest}>
      <StepHeader title="Your details" edit={edit} hasState={hasState} stepNumber={stepNumber} />
      <PersonalDetailsForm step={step} />
    </Box>
  );
};

PersonalDetails.propTypes = {
  step: PropTypes.shape({
    hasState: PropTypes.func,
    edit: PropTypes.func,
    stepNumber: PropTypes.number,
    containerRef: PropTypes.shape({ current: PropTypes.any }),
  }),
};

PersonalDetails.defaultProps = {
  step: {
    hasState: noop,
    edit: noop,
    containerRef: null,
  },
};

export default PersonalDetails;
